import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	row-gap: 20px;
	max-width: 300px;

	transition:
		opacity 0.5s ease,
		transform 0.5s ease;
	transform: translateX(100%);
	opacity: 0;

	&.quest-enter {
		opacity: 0;
		transform: translateX(100%);
	}

	&.quest-enter-active,
	&.quest-enter-done,
	&.quest-exit {
		opacity: 1;
		transform: translateX(0);
	}

	&.quest-exit-active {
		transform: translateX(100%);
		opacity: 0;
	}
`;

const StyledQuestType = styled.div<{
	$backgroundColor: string;
	$textColor: string;
}>`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 4px 6px;
	font-family: GT Walsheim Pro;
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	border-radius: 6px;

	background-color: ${(props) => props.$backgroundColor};
	color: ${(props) => props.$textColor};
`;

const StyledQuestTypeIcon = styled.img`
	flex-shrink: 0;
	width: 10px;
	height: 10px;
	user-select: none;
	pointer-events: none;
`;

export { StyledContainer, StyledQuestType, StyledQuestTypeIcon };
